/**
 * Tree relationship definitions for Azure Digital Twins (ADT) implementation.
 *
 * These define which REC relationships form hierarchical structures.
 * Up edges represent child → parent relationships.
 * Down edges represent parent → child relationships.
 */

// Up tree edges: relationships that point from child to parent
export const AdtUpTreeEdges = [
  'https://w3id.org/rec#isPartOf', // Space → Building, Building → RealEstate
  'https://w3id.org/rec#locatedIn', // Equipment → Space
  'https://brickschema.org/schema/Brick#isPointOf', // Point → Equipment (Brick namespace in context)
  'https://brickschema.org/schema/Brick#isSubMeterOf', // SubMeter → Meter (Brick namespace in context)
  'https://w3id.org/rec#leaseOf', // Lease → Space
  // 'https://w3id.org/rec#feeds', // Optional: System feeds distribution
]

// Down tree edges: relationships that point from parent to child
export const AdtDownTreeEdges = [
  'https://w3id.org/rec#hasPart', // Building → Space (inverse of isPartOf)
  'https://w3id.org/rec#includes', // Space → Equipment
  'https://w3id.org/rec#isLocationOf', // Space → Equipment (inverse of locatedIn)
  'https://w3id.org/rec#leasee', // Space → Lease (inverse of leaseOf)
]

/**
 * Super roots for organizing top-level tree nodes by type.
 * Creates virtual group nodes to organize the tree view.
 */
export const AdtSuperRoots = {
  RealEstates: 'RealEstate',
  Buildings: 'Building',
  Levels: 'Level',
  Apartments: 'Apartment',
}
